<template>
    <div class="ppt-state"
         :class="{'deep-black': theme === 'deep-black'}"
    >
        <div class="word" @mouseenter="$emit('flashPPT')">
            <span
                class="ico"
                :class="{
                    success: AllSuccess
                }"
            ></span>
            <el-popover
                    placement="bottom-start"
                    title=""
                    width="300"
                    trigger="hover">
                <div class="box">
                    <p class="title">PPT导入进度</p>
                    <div class="ppt-box">
                        <p
                            v-for="(item, index) in data"
                            :key="index"
                            class="row"
                        >
                            <span class="name">{{item.name}}</span>
                            <span :class="`state ${enumStatusClass[item.status]}`">{{enumStatus[item.status]}}</span>
                        </p>
                    </div>
                </div>
                <span class="name-box" slot="reference"><span class="iconfont icon-daoruPPT"></span></span>
            </el-popover>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ppt-upload-status",
        props: {
            theme: String,
            data: Array
        },
        computed: {
            //状态 0 等待 1转码成功 2 转码成功并插入PPT保存 3 失败 4 已取消(插入点击取消状态变为取消)
            enumStatus(){
                return {
                    3: '失败',
                    0: '加载中',
                    1: '加载中',
                    2: '完成',
                    4: '取消'
                }
            },
            enumStatusClass(){
                return {
                    3: 'fail',
                    0: 'loading',
                    1: 'loading',
                    2: 'success',
                    4: 'cancel'
                }
            },
            AllSuccess(){
                let state = false
                try {
                    if(this.data && this.data.length>0){
                        const newData = this.data.filter(v=>`${v.status}`==='2')
                        if(newData.length === this.data.length) state = true
                    }
                } catch (e) {
                    console.log('获取ppt上传所有状态失败==>', e)
                }
                return state
            }
        }
    }
</script>
<style>
    .el-popover.el-popper .box .title {
        font-size: 16px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
        padding: 17px 24px;
        border-bottom: 1px solid #E9E9E9;
    }
    .el-popover.el-popper .box .ppt-box{
        max-height: 50vh;
        overflow-y: auto;
    }
    .el-popover.el-popper .box .row{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin: 10px 20px;

    }
    .el-popover.el-popper .box .row .name {
        font-size: 14px;
        font-weight: 400;
        color: #303133;
        line-height: 20px;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .el-popover.el-popper .box .row .state.success{
        color: #52C41A;
    }
    .el-popover.el-popper .box .row .state.fail{
        color: #303133;
    }
    .el-popover.el-popper .box .row .state.loading{
        color: #c66;
    }
</style>
<style lang="scss" scoped>
    .name-box{
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .icon-daoruPPT{
        /*margin-right: 4px*/
    }
    .ppt-state{
        display: flex;
        /*position: absolute;*/
        /*left: 10px;*/
        /*top: 10px;*/
        z-index: 101;

        .word{
            font-size: 14px;
            font-weight: 400;
            color: #303133;
            line-height: 20px;
            position: relative;
            padding-left: 12px;

            .ico{
                position: absolute;
                top: -2px;
                right: -5px;
                width: 7px;
                height: 7px;
                background: #F5222D;
                border-radius: 50%;

                &.success{
                    background-color: #52C41A;
                }
            }
        }
    }
    .ppt-state.deep-black{
        .word{
            color: #BDBEC7;
        }
        .icon-daoruPPT{
            color: #BDBEC7;
        }
    }
</style>
